module.exports = __webpack_public_path__ + "static/media/video_dart.9d0591a4.svg";